import { Box, Container, Grid, Typography } from '@mui/material'
import { Navigate } from 'react-router-dom'
import CreditsAdd from '../components/admin/credits-add'
import { features } from '../config/features'
import { useAuth } from '../providers/auth'

export default function CreditsAdmin() {
  const { admin } = useAuth()

  if (!admin) return <Navigate to="/" replace />
  if (!features.credits) return <Navigate to="/admin" replace />

  return (
    <Container maxWidth="md" sx={{ position: 'relative' }}>
      <Box sx={{ height: 16 }} />
      <Grid container spacing={2} alignItems="flex-start">
        <Grid item xs={12}>
          <Typography variant="h6" component="h1">
            Credits
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Hantera förköpta credits separat från övrig administration.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <CreditsAdd showHeading={false} />
        </Grid>
      </Grid>
      <Box sx={{ height: 64 }} />
    </Container>
  )
}
